import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref, watch, nextTick } from "vue";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css'
import markerIcon from '@/assets/location/icon.png'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import deleteSrc from '@/assets/location/delete.svg';
import editSrc from '@/assets/location/edit.svg';
import { getMapBoxToken } from "@/api/map";
import { getUserIp } from "@/api/ip";
import { useStore } from "vuex";
import { getAddressInfo } from "@/utils/mapFun";


export default /*#__PURE__*/_defineComponent({
  __name: 'map',
  props: {
    functionPage: {//功能页
        type: String,
        require: true
    },
    lcoationMap: {//经纬度
        type: Array
    },
    searchText: {//查询的地址
        type: String
    },
    locationCircles: {//
        type: Array
    },
    locationRadius: {//创建围栏的半径
        type: Number
    },
    geofenceList: {//围栏的数据
        type: Array
    },
    isCreate: {//是否是创建还是更新围栏
        type: Boolean
    },
    editId: {//围栏id
        type: String,
        default: ''
    },
    locationNameItem: {
        type: String,//location的名称
    },
    styleString: {//地图的大小
        type: Object,
        default: {
            width: 'calc(100vw - 257px - 361px)',
            height: 'calc(100vh - 120px)'
        }
    }
},
  emits: ['selectLocationArray', 'updateLocationName', 'editLocationFun', 'deleteLocationFun'],
  setup(__props, { emit: Emits }) {

const props = __props;



//初始化地图
let mapData: any = null;
let geocoder: any = null;
let locationName = ref('')
const maplnglat = ref([])//经纬度全都存到当前页面
const mapRadius = ref([])//半径全都存到当前页面
const editIdlo = ref('')//编辑围栏id
const store = useStore();
const circleNewArray = ref([
    {
        circleId: 'circle-1',
        lnglat: [114.05707034393225, 22.535650559336915],
        radius: 1, // 初始半径
    }
])//画圈圈的数组
const selectLocationArray = ref([])
const isFirst = ref(false)//是否第一次进入围栏
let accessToken = ref('')
//初始化地图
const initMap = async () => {
    console.log("???>?>?>?");

    mapboxgl.accessToken = accessToken.value;
    mapData = new mapboxgl.Map({
        container: 'mapRightBox', // container ID
        style: 'mapbox://styles/mapbox/streets-v12', // style URL
        // center: [118.127, 24.491], // starting position [lng, lat]
        center: props.lcoationMap, // starting position [lng, lat]
        zoom: 15, // starting zoom
        language: 'zh-Hans', // 使用简体中文
    });
    let currentMarker: any = null;

    // 添加自定义 Marker 图标
    const el = document.createElement('img');
    el.src = markerIcon;
    el.style.width = '48px';
    el.style.height = '48px';

    currentMarker = new mapboxgl.Marker(el).setLngLat(props.lcoationMap)
        .addTo(mapData);

    // 创建 Geocoder 控件
    geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        // 添加 "flyTo" 选项来禁止自动聚焦到插件自带的输入框
        // flyTo: false,
    });

    // 将 Geocoder 控件添加到地图上
    mapData.addControl(geocoder);

    // 监听 Geocoder 的结果事件
    geocoder.on('results', (e: any) => {
        console.log("geocoderResult:", e.features);
        console.log("geocoderResult:", e.features.map((item: any) => item.place_name));
        selectLocationArray.value = e.features.map((item: any) => ({ label: item.place_name, value: item.place_name, center: item.center, text: item.text }));
        Emits('selectLocationArray', selectLocationArray.value)
        // const [lng, lat] = e.result.center;
        // mapData.setCenter([lng, lat]);
    });
    if (props.functionPage == 'location') {
        let res: any = await getAddressInfo(props.lcoationMap, true)
        getAddressInfoAfter()
        console.log("getAddressInfo:", res[0], res[1]);
    }
    drawCircle()
    // 创建用于显示地址信息的元素
    const addressInfoElement = document.createElement('div');
    addressInfoElement.className = 'address-info'; // 通过 CSS 样式设置其样式
    mapData.getCanvasContainer().appendChild(addressInfoElement);

    // 鼠标进入 el 元素时的事件处理函数
    el.addEventListener('mouseenter', () => {
        if (props.functionPage == 'geofencing') return
        console.log("触碰到el了：", el.style.transform);
        addressInfoElement.style.display = 'block';
        console.log("props.locationNameItem:", props.locationNameItem);

        addressInfoElement.textContent = props.locationNameItem; // 设置要显示的地址信息
        addressInfoElement.style.transform = el.style.transform
    });

    // 鼠标离开 el 元素时的事件处理函数
    el.addEventListener('mouseleave', () => {
        if (props.functionPage == 'geofencing') return

        addressInfoElement.style.display = 'none';
    });
    mapData.on('click', async function (e: any) {
        if (props.functionPage == 'location') return

        // console.log("currentMarker:", currentMarker);
        // console.log("props.functionPage：", props.functionPage);
        // if (currentMarker) {
        //     currentMarker.remove(); // 移除之前的标记
        // }

        // const el = document.createElement('img');
        // el.src = markerIcon; // 获取不同图标的函数
        // el.style.width = '48px';
        // el.style.height = '48px';

        // // 创建标记并添加到点击位置
        // currentMarker = new mapboxgl.Marker(el)
        //     .setLngLat(e.lngLat)
        //     .addTo(mapData);
        let res = await getAddressInfo(e.lngLat)
        getAddressInfoAfter(res)
        console.log("getAddressInfo111:", res[0], res[1]);

    });

}
const getAddressInfoAfter = (data: any) => {
    locationName.value = data[0];
    Emits('updateLocationName', locationName.value, data[1])
    if (props.functionPage == 'geofencing') {
        console.log("!!!!");
        circleNewArray.value[0].lnglat = data[1]
        // mapData.flyTo({ center: data.features[0].center, zoom: 12 });
        updateCircle(data[1], props.locationRadius)
    }
}
//获取地图信息
// const getAddressInfo = (e: any, isFirst?: any) => {
//     console.log("e:", e);
//     let lng = e[0] ? e[0] : e.lng
//     let lat = e[1] ? e[1] : e.lat
//     console.log("lng,lat:", lng, lat);
//     let lnglat = [lng, lat]
//     const geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${accessToken.value}`;
//     // 使用 Geocoding API 获取地址信息
//     fetch(geocodingUrl)
//         .then(function (response) {
//             return response.json();
//         })
//         .then(function (data) {
//             // 获取第一个匹配结果的地址信息
//             // locationName.value = data.features[0].text;
//             locationName.value = data.features[0].place_name;
//             Emits('updateLocationName', locationName.value, lnglat)
//             console.log("?????");

//             if (props.functionPage == 'geofencing') {
//                 console.log("!!!!");
//                 circleNewArray.value[0].lnglat = lnglat
//                 // mapData.flyTo({ center: data.features[0].center, zoom: 12 });
//                 updateCircle(lnglat, props.locationRadius)
//             }
//             console.log('Clicked at: ' + data.features[0].place_name);
//         });
// }
//搜索地图信息
const handleSearch = (searchText: any) => {
    // 使用 searchText.trim() 来处理搜索框的输入值
    const trimmedSearch = searchText.trim();
    nextTick(() => {
        // 将搜索框输入作为搜索关键字传递给地点搜索 API
        geocoder.query(trimmedSearch); // 使用 trimmedSearch
    })
}
const metersToPixelsAtMaxZoom = (meters: any, latitude: any) => {
    return meters / 0.075 / Math.cos(latitude * Math.PI / 180)
}
//画圈圈
const drawCircle = () => {

    setTimeout(() => {
        mapData.on('load', () => {
            console.log("circleNewArray:", circleNewArray.value);
            circleNewArray.value.forEach((circle, index) => {
                // const screenPoint = mapData.project(circle.radius); // 将地理坐标转换为屏幕坐标
                console.log("circle:", circle.loIndex);
                const circleLayer = mapData.getLayer(`circle-${index + 1}`);
                if (circleLayer) return
                console.log("circleLayer:", circleLayer);

                // const radiusInMeters = 100; // 假设半径为 100 米
                const circleRadiusInPixels = metersToPixelsAtMaxZoom(circle.radius, circle.lnglat[1]); // 0.075 是一个估计的屏幕距离因子
                console.log("circleRadiusInPixels:", circleRadiusInPixels, `circle-${index + 1}`);

                mapData.addLayer({
                    id: `circle-${index + 1}`,
                    type: 'circle',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: circle.lnglat
                            }
                        }
                    },
                    paint: {
                        'circle-color': ["rgba", 64, 128, 255, 0.2],
                        // 'circle-radius': 100
                        "circle-radius": {
                            stops: [   // 重点
                                [0, 0],
                                [20, circleRadiusInPixels],
                            ],
                            base: 2,
                        },
                    }
                });
                circle.circleId = `circle-${index + 1}`
                if (circle.circleId == 'circle-1') return
                console.log("circle.id:", circle.id);
                //hover产生的dom
                let currentMarker: any = null;
                const circleDiv: HTMLDivElement = document.createElement('div');
                circleDiv.className = `circle-marker circleMarker-${index + 1}`; // Add appropriate styling`circle-${index + 1}`
                circleDiv.style.width = `220px`;
                circleDiv.style.height = `42px`;
                circleDiv.style.padding = `7px 10px`;
                circleDiv.style.display = 'none';
                circleDiv.style.marginTop = '60px';
                circleDiv.subID = index
                const infoSpan = document.createElement('span');
                infoSpan.textContent = circle.name; // Replace with your content
                infoSpan.style.width = '140px';
                infoSpan.style.whiteSpace = 'nowrap'; // Prevent line break
                infoSpan.style.overflow = 'hidden';
                infoSpan.style.textOverflow = 'ellipsis';
                infoSpan.style.lineHeight = '29px';
                infoSpan.style.fontSize = '14px';
                circleDiv.appendChild(infoSpan);
                const editIcon = document.createElement('img');
                editIcon.src = editSrc; // Replace with your edit icon image source
                editIcon.className = 'icon';
                circleDiv.appendChild(editIcon);
                const deletIcon = document.createElement('img');
                deletIcon.src = deleteSrc; // Replace with your delete icon image source
                deletIcon.className = 'icon';
                circleDiv.appendChild(deletIcon);


                currentMarker = new mapboxgl.Marker(circleDiv).setLngLat(circle.lnglat)
                    .addTo(mapData);
                //hover事件要变色和展示消失
                let aa
                mapData.on("mouseenter", `circle-${index + 1}`, function (e: any) {
                    if (!props.isCreate) return
                    console.log("触碰到circleDiv了11111111111：", circle.loIndex);
                    mapData.setPaintProperty(`circle-${index + 1}`, 'circle-color', ["rgba", 64, 128, 255, 0.4]); // Red color with alpha
                    circleDiv.style.display = 'flex';
                    // aa = null
                    clearTimeout(aa)
                })
                mapData.on("mouseleave", `circle-${index + 1}`, function (e: any) {
                    console.log("离开circleDiv了2222222222222222：", circle.loIndex);

                    mapData.setPaintProperty(`circle-${index + 1}`, 'circle-color', ["rgba", 64, 128, 255, 0.2]);
                    // Red color with alpha 
                    if (!window.statusIn) {
                        aa = setTimeout(() => {
                            circleDiv.style.display = 'none';
                        }, 500)
                    }

                    console.log('window.statusIn', window.statusIn);

                })
                console.log("circleDiv545555555555555:", circleDiv);

                circleDiv.addEventListener("mouseenter", function (e: any) {
                    console.log("mouseentermouseentermouseenter", circle.loIndex);
                    console.log("circleDivcircleDivcircleDiv:", circleDiv);
                    window.statusIn = true
                    // aa = setTimeout(() => {
                    // circleDiv.style.display = 'flex';

                    // }, 200)
                    // circleDiv.style.display = 'flex';
                    clearTimeout(aa)
                })
                circleDiv.addEventListener("mouseleave", function (e: any) {
                    console.log("mouseleavemouseleavemouseleave", circle.loIndex);
                    console.log("circleDivcircleDivcircleDiv:", circleDiv);
                    window.statusIn = false
                    // aa = setTimeout(() => {
                    // circleDiv.style.display = 'flex';

                    // }, 200)
                    // circleDiv.style.display = 'flex';
                    clearTimeout(aa)

                    aa = setTimeout(() => {
                        circleDiv.style.display = 'none';
                    }, 1000);
                })
                // circleDiv.addEventListener("mouseleave", function (e: any) {
                //     console.log("离开弹窗了44444444444：", circle.loIndex);

                //     mapData.setPaintProperty(`circle-${index + 1}`, 'circle-color', ["rgba", 64, 128, 255, 0.2]); // Red color with alpha
                //     // aa = setTimeout(() => {
                //     // circleDiv.style.display = 'none';
                //     // }, 500)
                // })
                // Add click event listener to deletIcon
                editIcon.addEventListener('click', (event: any) => {
                    // Handle delete icon click logic
                    event.stopPropagation();
                    Emits('editLocationFun', circle)

                    console.log('edit icon clicked:', circle);

                });
                // Add click event listener to deletIcon
                deletIcon.addEventListener('click', (event: any) => {
                    // Handle delete icon click logic
                    event.stopPropagation();
                    Emits('deleteLocationFun', circle)

                    console.log('Delete icon clicked:', circle);
                });
                if (circle.loIndex) {
                    const el = document.createElement('div');
                    el.className = 'circleCenterNum';
                    el.style.background = circle.color.color
                    el.style.borderRadius = '50%'
                    el.style.textAlign = 'center'
                    el.style.lineHeight = '28px'
                    el.innerHTML = `${circle.loIndex}`
                    const popup = new mapboxgl.Marker(el).setLngLat(circle.lnglat)
                        .addTo(mapData);
                }

            })

        });
    })
}
const updateCircle = (lnglat?: any, radius?: any) => {
    console.log("开始更新圈圈:", lnglat, radius);
    let circleContent
    let templng = [] as any
    if (!props.isCreate && editIdlo.value) {
        console.log("circleNewArray:", circleNewArray.value);
        circleContent = circleNewArray.value.filter((item: any) => item.id == editIdlo.value)
        console.log("circleContent:", circleContent);

        templng = circleContent[0].lnglat
    }
    console.log("查看是否是编辑还是创建:", props.isCreate, editIdlo.value, circleContent);

    const newRadius = radius ? radius : '';
    let circle = props.isCreate ? circleNewArray.value[0] : circleContent[0]
    // if (circleContent[0])
    // let circle = circleNewArray.value[0]
    let newLnglat = lnglat ? lnglat : templng.length > 0 ? templng : circleNewArray.value[0].lnglat
    console.log("circle:", circle);
    console.log("circle.id:", circle.id);
    console.log("newLnglat:", newLnglat);
    console.log("mapData:", mapData);
    console.log(" mapData.getSource(circle.id):", mapData.getSource(circle.circleId));
    if (!isFirst.value) {
        isFirst.value = true
        return
    }
    // 更新图层数据
    mapData.getSource(circle.circleId).setData({
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: newLnglat
        }
    });
    const circleRadiusInPixels = metersToPixelsAtMaxZoom(newRadius, newLnglat[1]);
    console.log("circleRadiusInPixels:", circleRadiusInPixels, circle);

    mapData.setPaintProperty(circle.circleId, 'circle-radius', {
        stops: [
            [0, 0],
            [20, circleRadiusInPixels],
        ],
        base: 2,
    });
}
watch(() => props.lcoationMap, () => {
    console.log("经纬度变化了:", props.lcoationMap);
    // mapData.setCenter(props.lcoationMap);
    setTimeout(async () => {
        initMap()
        if (props.functionPage == 'geofencing') {
            let res = await getAddressInfo(props.lcoationMap)
            console.log("getAddressInfo222:", res[0], res[1]);

        }

    }, 1000)
}, {
    immediate: true,
    deep: true
})
watch(() => props.searchText, () => {
    console.log("搜索的内容变了:", props.searchText);
    handleSearch(props.searchText)
})
watch(() => props.locationCircles, () => {
    console.log("地理围栏的circle变了", props.locationCircles);
})
watch(() => props.locationRadius, () => {
    console.log("地理围栏的locationRadius变了", props.locationRadius, props.isCreate);
    setTimeout(() => {
        updateCircle(null, props.locationRadius)
    }, 100)
})
watch(() => props.editId, () => {
    console.log("地理围栏的编辑id变了", props.editId);
    editIdlo.value = props.editId
}, {
    immediate: true,
})
watch(() => props.geofenceList, () => {
    console.log("地理围栏的list圈圈数组变了", props.geofenceList);
    circleNewArray.value = [
        {
            circleId: 'circle-1',
            lnglat: [114.05707034393225, 22.535650559336915],
            radius: 1, // 初始半径
        }
    ]
    props.geofenceList?.forEach((item: any, index: any) => {
        item.lnglat = [item.longitude, item.latitude]
        circleNewArray.value.push(item)
    })
    console.log("circleNewArray.value:", circleNewArray.value);

})
onMounted(() => {
    console.log("初始化地图");
    getUserIp({}).then((res: any) => {
        let ip = res.data.data.ip;
        console.log("获取ip成功:", ip);
    }
    ).catch((e) => {
        console.log("获取ip失败:", e);

    });
    const ipApiUrl = 'https://ipapi.co/json/';
    fetch(ipApiUrl)
        .then((response) => response.json())
        .then((data) => {
            const latitude = data.latitude;
            const longitude = data.longitude;

            console.log('经度：', longitude);
            console.log('纬度：', latitude);
            if (props.lcoationMap && props.lcoationMap[0] == 0 && props.lcoationMap[0] == 0) {
                setTimeout(() => {
                    console.log("mapData:", mapData);
                    mapData.setCenter([longitude, latitude]);
                }, 1000)
            }
            // 
            console.log("props.location:", props.lcoationMap);

        })
        .catch((error) => {
            console.error('获取地理位置信息出错：', error);
        });
    // const maptokenUrl = "https://integrated.afirstsoft.cn/api/v1/mapbox/getMapBoxToken";
    // 使用 Geocoding API 获取地址信息
    getMapBoxToken({}).then((res) => {
        console.log("ressssss:", res);
        accessToken.value = res.data
        // store.state.accessToken = res.data
        store.commit("setAccessToken", res.data);

    })
        .catch((e) => {
            console.log("e:", e);

        })

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "mapRightBox",
    style: _normalizeStyle(__props.styleString)
  }, null, 4))
}
}

})